import React, { useState } from "react"
import { Tooltip, OverlayTrigger } from "react-bootstrap"
import { useSelector } from "react-redux"

import { getProductField, getSettings } from "@/onboarding/features/product/selectors"
import TextDisplay from "@/onboarding/features/product/components/shared/TextDisplay"
import OperatorOnly from "@/auth_descriptor/OperatorOnly"

export const InlineDisplayValue = ({ name }): JSX.Element => {
  const { value } = useSelector(getProductField(name))

  return <TextDisplay value={value} />
}

export const DisplayValue = ({
  name,
  label = undefined,
  requiredField = false,
  incompleteField = false,
}): JSX.Element => {
  const { value } = useSelector(getProductField(name))

  return (
    <div className="d-flex flex-column gap-1">
      {label && (
        <span>
          <b>
            {label}
            <OperatorOnly>
              {requiredField && incompleteField && (
                <span
                  data-toggle="tooltip"
                  data-placement="top"
                  title="This is an incomplete required field"
                  className="ms-1"
                  style={{ color: "red" }}
                >
                  *
                </span>
              )}
            </OperatorOnly>
          </b>
        </span>
      )}
      <TextDisplay value={value} />
    </div>
  )
}

const DisplayChangedValue = ({
  name,
  label,
  previousValue,
  requiredField = false,
  incompleteField = false,
}): JSX.Element => {
  const { value } = useSelector(getProductField(name))

  const [showPrevious, setShowPrevious] = useState(false)

  const handleToggle = () => setShowPrevious(!showPrevious)

  return (
    <div className="d-flex flex-column gap-1 cursor-pointer">
      <div
        className="d-flex align-items-center"
        onClick={handleToggle}
        style={{ cursor: "pointer" }}
      >
        <b className="yellow-underline">
          {label}
          <OperatorOnly>
            {requiredField && incompleteField && (
              <OverlayTrigger
                overlay={
                  <Tooltip id={`tooltip-incomplete-${name}`}>
                    This is an incomplete required field
                  </Tooltip>
                }
                placement="top"
              >
                <span className="ms-1" style={{ color: "red" }}>
                  *
                </span>
              </OverlayTrigger>
            )}
          </OperatorOnly>
        </b>
        <small className="ms-2 text-muted fst-italic">{showPrevious ? "Original" : ""}</small>
      </div>
      {showPrevious ? (
        <TextDisplay value={previousValue} previousValue />
      ) : (
        <TextDisplay value={value} />
      )}
    </div>
  )
}

const Field = ({ name, label }) => {
  const fieldsSettings = useSelector(getSettings(name))

  const changedField = fieldsSettings[name]?.changed
  const previousValue = fieldsSettings[name]?.previousValue

  return changedField ? (
    <DisplayChangedValue
      key={name}
      name={name}
      label={label}
      requiredField={fieldsSettings[name]?.required}
      incompleteField={fieldsSettings[name]?.incomplete}
      previousValue={previousValue}
    />
  ) : (
    <DisplayValue
      key={name}
      name={name}
      label={label}
      requiredField={fieldsSettings[name]?.required}
      incompleteField={fieldsSettings[name]?.incomplete}
    />
  )
}

export default Field
